import FlightsSearchControlsGCWrapper from './FlightsSearchControlsGCWrapper';

export default FlightsSearchControlsGCWrapper;
